const HMRClient = require('react-native/Libraries/Utilities/HMRClient');

export default HMRClient;
